// Keep the optional monitoring SDK in a separate production bundle.
export function loadBrowserErrors() {
  return import('./browserErrors');
}
